import {
  $SpecialGradeLevel,
  Locale,
  LoginType,
  SpecialGradeLevel,
} from '@suntex.fim/enums';

import {
  RankingsSlug,
  playerGradeOptions,
  schoolGradeOptions,
  teamsGradeOptions,
} from '../const';

const specialGradeLevelOptions = $SpecialGradeLevel.listOptions();

export function getDefaultGrade(rankingsSlug: RankingsSlug): SpecialGradeLevel {
  switch (rankingsSlug) {
    case RankingsSlug.SchoolInternational:
    case RankingsSlug.SchoolNation:
    case RankingsSlug.SchoolState:
    case RankingsSlug.SchoolSystem:
    case RankingsSlug.SchoolDistrict:
      return SpecialGradeLevel.Top100Students;
    default:
      return SpecialGradeLevel.AllGrades;
  }
}

export function getGradeOptions(
  rankingsSlug: RankingsSlug,
): readonly { key: SpecialGradeLevel; label: string }[] {
  switch (rankingsSlug) {
    case RankingsSlug.SchoolInternational:
    case RankingsSlug.SchoolNation:
    case RankingsSlug.SchoolState:
    case RankingsSlug.SchoolSystem:
    case RankingsSlug.SchoolDistrict:
      return schoolGradeOptions.map(
        (key) => specialGradeLevelOptions.find((option) => option.key === key)!,
      );
    case RankingsSlug.TeamInternational:
    case RankingsSlug.TeamNation:
    case RankingsSlug.TeamState:
    case RankingsSlug.TeamSystem:
    case RankingsSlug.TeamDistrict:
    case RankingsSlug.TeamSchool:
      return teamsGradeOptions.map((key) =>
        key === SpecialGradeLevel.AllGrades
          ? { key, label: 'Top 10 Students, All Grades' }
          : specialGradeLevelOptions.find((option) => option.key === key)!,
      );
    default:
      return playerGradeOptions.map(
        (key) => specialGradeLevelOptions.find((option) => option.key === key)!,
      );
  }
}

export function shouldDisplayRankings(
  rankingSlug: RankingsSlug,
  { loginType, locale }: { locale: Locale; loginType: LoginType },
) {
  switch (rankingSlug) {
    case RankingsSlug.SchoolInternational:
    case RankingsSlug.TeamInternational:
    case RankingsSlug.PlayerInternational:
      return locale === Locale.IN;
    case RankingsSlug.CombinedFamilySystem:
    case RankingsSlug.EducatorSystem:
    case RankingsSlug.FamilySystem:
    case RankingsSlug.PlayerSystem:
    case RankingsSlug.SchoolSystem:
    case RankingsSlug.TeamSystem:
      return (
        loginType >= LoginType.RegionAdmin &&
        loginType <= LoginType.SchoolPrincipal
      );
    case RankingsSlug.CombinedFamilyDistrict:
    case RankingsSlug.EducatorDistrict:
    case RankingsSlug.FamilyDistrict:
    case RankingsSlug.PlayerDistrict:
    case RankingsSlug.SchoolDistrict:
    case RankingsSlug.TeamDistrict:
      return (
        loginType >= LoginType.DistrictAdmin &&
        loginType <= LoginType.SchoolPrincipal
      );
    case RankingsSlug.CombinedFamilySchool:
    case RankingsSlug.EducatorSchool:
    case RankingsSlug.FamilySchool:
    case RankingsSlug.PlayerSchool:
    case RankingsSlug.TeamSchool:
      return (
        loginType >= LoginType.TeamLeader &&
        loginType <= LoginType.SchoolPrincipal
      );
    default:
      return false;
  }
}

export function shouldDisplayLevelDropdown(rankingSlug: RankingsSlug) {
  switch (rankingSlug) {
    case RankingsSlug.TeamInternational:
    case RankingsSlug.TeamNation:
    case RankingsSlug.TeamState:
    case RankingsSlug.TeamSystem:
    case RankingsSlug.TeamDistrict:
    case RankingsSlug.TeamSchool:
      return true;
    default:
      return false;
  }
}

export function shouldDisplayState(rankingSlug: RankingsSlug) {
  switch (rankingSlug) {
    case RankingsSlug.SchoolState:
    case RankingsSlug.TeamState:
    case RankingsSlug.PlayerState:
    case RankingsSlug.EducatorState:
    case RankingsSlug.FamilyState:
    case RankingsSlug.CombinedFamilyState:
      return true;
    default:
      return false;
  }
}
